// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__QmLz6","errorLogs":"styles_errorLogs__2E2JO"};